//Include Both Helper File with needed methods
import {
    postLogin,
    postLogout,
} from "../../../helpers/backend_helper";

import {loginSuccess, logoutUserSuccess, apiError, reset_login_flag} from './reducer';
import { setToken, clearToken } from "../../authSlice";
import { getPrimaryShopId } from "../../../helpers/shop";
import axios from "../../../helpers/axiosConfig";
import { registerWebPushSubscription, unregisterWebPushSubscription } from "../../../helpers/pushNotifications";
import { resolveApiMessage } from "../../../helpers/apiMessage";

const getLoginErrorMessage = (error: any): any => {
    return resolveApiMessage(error, { fallbackMessage: "Đăng nhập thất bại. Vui lòng thử lại." });
};

export const loginUser = (user: any, history: any) => async (dispatch: any) => {

    try {
        await axios.get('/sanctum/csrf-cookie', { withCredentials: true });

        await postLogin({
            email: user.email,
            password: user.password,
        });

        const userResponse = await axios.get("/api/user", { withCredentials: true });

        const data = userResponse?.data ?? userResponse;

        if (data) {
            const authUser = data.user ?? data;

            if (authUser) {
                const session = {
                    user: authUser,
                };

                localStorage.setItem("authUser", JSON.stringify(session));
                dispatch(setToken({ user: session.user }));
                dispatch(loginSuccess(session));
                try {
                    await unregisterWebPushSubscription();
                } catch (error) {
                    console.warn("Failed to clean up stale web push subscription before login registration:", error);
                }
                void registerWebPushSubscription();

                if (!authUser.email_verified_at) {
                    history('/verify-email');
                } else if (!getPrimaryShopId(authUser)) {
                    history('/create-shop');
                } else {
                    history('/order');
                }
            } else {
                dispatch(apiError(getLoginErrorMessage(data)));
            }
        }
    } catch (error: any) {
        dispatch(apiError(getLoginErrorMessage(error)));
    }
};

export const logoutUser = () => async (dispatch: any) => {
    try {
        await unregisterWebPushSubscription();
    } catch (error) {
        console.warn("Failed to unregister web push subscription:", error);
    }

    try {
        await postLogout();
    } catch (error: any) {
        dispatch(apiError(error));
    } finally {
        localStorage.removeItem("authUser");
        dispatch(clearToken());
        dispatch(logoutUserSuccess(true));
    }
};

export const resetLoginFlag = () => async (dispatch: any) => {
    try {
        const response = dispatch(reset_login_flag());
        return response;
    } catch (error: any) {
        dispatch(apiError(error));
    }
};
